import { isDefined } from '@sgme/fp';
import type { IntlKey } from 'locales';
import { useIntl } from 'react-intl';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';

export function getTradeWayDetailLabel(side?: TradeWay): IntlKey | undefined {
  switch (side) {
    case 'ClientBuy':
      return 'secondaryMarket.sidePanel.label.youBuyWayDetail';
    case 'ClientSell':
      return 'secondaryMarket.sidePanel.label.youSellWayDetail';
    default:
      return;
  }
}

export function getTradeWayLabel(side?: TradeWay): IntlKey | undefined {
  switch (side) {
    case 'ClientBuy':
      return 'secondaryMarket.sidePanel.label.youBuy';
    case 'ClientSell':
      return 'secondaryMarket.sidePanel.label.youSell';
    default:
      return;
  }
}

export type FormatTradeWayLabel = { way?: TradeWay; withoutWayDetail?: boolean };
export const useTradeWayLabel = ({ way, withoutWayDetail }: FormatTradeWayLabel) => {
  const { formatMessage } = useIntl();
  const label = withoutWayDetail ? getTradeWayLabel(way) : getTradeWayDetailLabel(way);
  return isDefined(label) ? formatMessage({ id: label }) : undefined;
};
